import type { RouteObject } from 'react-router-dom';

export const paymentRoutes: RouteObject[] = [
  { path: 'paiement/retour', lazy: () => import('./PaymentReturnPage').then((m) => ({ Component: m.PaymentReturnPage })) },
  { path: 'paiement/simulation', lazy: () => import('./SandboxCheckoutPage').then((m) => ({ Component: m.SandboxCheckoutPage })) },
  { path: 'verifier/:number', lazy: () => import('./ReceiptVerifyPage').then((m) => ({ Component: m.ReceiptVerifyPage })) },
];
